export const MOBILE_MODAL_MEDIA_QUERY = "(max-width:400px)";
